import React, { useEffect, useRef } from 'react';

interface EmbedRendererProps {
  snippet: string;
}

const EmbedRenderer: React.FC<EmbedRendererProps> = ({ snippet }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const insertedScripts = useRef<HTMLScriptElement[]>([]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Limpar scripts e HTML anteriores
    insertedScripts.current.forEach(script => script.remove());
    insertedScripts.current = [];
    container.innerHTML = ''; // Limpa o HTML renderizado anteriormente

    // 1. Usar DOMParser para analisar o snippet de forma segura
    const parser = new DOMParser();
    const doc = parser.parseFromString(snippet, 'text/html');
    
    // 2. Transferir o conteúdo do body do documento parseado para o container
    // Isso renderiza o HTML estático
    Array.from(doc.body.childNodes).forEach(node => {
      container.appendChild(node.cloneNode(true));
    });

    // 3. Encontrar e executar scripts
    const scripts = Array.from(doc.querySelectorAll('script'));
    scripts.forEach(originalScript => {
      const newScript = document.createElement('script');
      
      // Copiar atributos (src, async, defer, etc.)
      Array.from(originalScript.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });

      // Copiar conteúdo inline, se houver
      if (originalScript.textContent) {
        newScript.textContent = originalScript.textContent;
      }

      // Adicionar ao container e registrar para limpeza
      // Usar o container em vez de document.body para manter o escopo
      container.appendChild(newScript);
      insertedScripts.current.push(newScript);
    });

    // Cleanup function para remover scripts quando o componente desmontar ou o snippet mudar
    return () => {
      insertedScripts.current.forEach(script => script.remove());
      insertedScripts.current = [];
      if (container) {
        container.innerHTML = ''; // Limpa o HTML também na desmontagem
      }
    };
  }, [snippet]); // Re-executar quando o snippet mudar

  return <div ref={containerRef} className="embedded-content-container my-4 flex justify-center items-center" />;
};

export default EmbedRenderer; 